import React from 'react';
import ContentIconAtom from '@atoms/icon-atoms/content-icon-atoms';
import styled from '@emotion/styled/macro';
import vars from '@variables';
import { FlexibleLinkAtom } from './link-atoms';
import { getGtmLinkId } from '@utils/utils';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { Link } from 'gatsby';
import { CallToActionLinkAtomsProps } from './link-atoms.types';

const CallToActionLinkAtom: React.FC<CallToActionLinkAtomsProps> = ({
  className,
  buttonText,
  url,
  isExternal = false,
  highlightColour,
}) => {
  if (buttonText && url) {
    if (isExternal) {
      return (
        <FlexibleLinkAtom
          url={url}
          gtmId={url ? `cta-button-${getGtmLinkId(url)}` : undefined}
          dataTestId="call-to-action-link-atom-external"
          className={className}
        >
          <span className="button-text">{buttonText}</span>
          <ContentIconAtom contentType="externalLink" height={27} width={27} />
        </FlexibleLinkAtom>
      );
    } else {
      return (
        <Link
          to={url}
          data-gtm-id={GTM_ID.CTA_BUTTON_INTERNAL_LINK}
          data-testid="call-to-action-link-atom-internal"
          className={className}
        >
          <span className="button-text">{buttonText}</span>
        </Link>
      );
    }
  } else {
    console.warn(
      `Call To Action Link Atom called with missing props. buttonText: ${buttonText}, url: ${url}`
    );
    return null;
  }
};

// === CallToActionLinkAtom CSS ===
const StyledCallToActionLinkAtom = styled(CallToActionLinkAtom)`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: ${vars.white};
  text-decoration: none;
  padding: 1.4rem ${vars.spacingM};
  height: 4.3rem;
  width: max-content;
  border-radius: 2px;

  & > .button-text {
    color: ${vars.coreDarkGrey} !important;
    ${vars.fontSize2}
    background: none !important;
    font-weight: ${vars.fontWeightBold};
    line-height: 1.4;
    letter-spacing: -0.02em;
    &:first-letter {
      text-transform: uppercase;
    }
  }
  ${({ highlightColour }) =>
    highlightColour ? `border: 1px solid ${highlightColour}` : null};
  ${ContentIconAtom} {
    position: relative;
    top: -3px;
    margin-left: 1.2rem;
  }
  &:hover {
    background: ${({ highlightColour }) =>
      highlightColour || vars.coreDarkGrey} !important;
    > .button-text {
      color: white !important;
    }
    cursor: pointer;
    svg {
      fill: white;
      rect {
        fill: none;
      }
    }
  }
`;

export default StyledCallToActionLinkAtom;
